import styled from "styled-components";
import { Container, SectionTitle } from "../styles/globalStyles";
import { motion } from "framer-motion";

const data = [
  {
    id: 1,
    company: "Highspot",
    role: "Senior Software Engineer",
    fromDate: new Date("2023-09-01"),
    toDate: new Date(), // Present
    tasks: [
      "Developed meeting analysis engine integrating Zoom and Proprietary Centinal APIs for 2000+ monthly meetings",
      "Engineered interactive timeline visualization components with optimized React rendering and MongoDB data aggregation for 500+ client dashboards",
      "Built end-to-end timeline-based feedback system with scalable backend processing and responsive UI used by 200+ sales managers",
      "Architected RESTful APIs and frontend components for third-party lesson integrations extending Highspot's core platform",
      "Led technical sessions for 15+ engineers covering React, Node.js, and MongoDB, earning Hackweek 2024 winner and multiple Employee of the Month awards",
    ],
  },
  {
    id: 2,
    company: "Deepen AI",
    role: "Senior Software Engineer",
    fromDate: new Date("2020-02-01"),
    toDate: new Date("2023-08-31"),
    tasks: [
      "Built full-stack 3D and 2D annotation platforms using React, Node.js, MongoDB, and Angular",
      "Developed the Calibration Suite using reusable components in Next.js, reducing load times by 90%",
      "Designed REST APIs and MongoDB models to support complex sensor calibration workflows",
      "Built dashboards using Chart.js and Mongo aggregations to track metrics for 320+ annotators",
    ],
  },
  {
    id: 3,
    company: "Deepen AI",
    role: "Software Engineer",
    fromDate: new Date("2019-06-01"),
    toDate: new Date("2020-01-31"),
    tasks: [
      "Rewrote the legacy 2D annotation tool in React, significantly improving performance and stability",
      "Built backend APIs for annotation workflows, enabling efficient data retrieval and processing",
      "Implemented auto-assign logic and visual task grids to streamline annotator workload management",
      "Integrated role-based access controls and toast notifications to enhance UX and security",
    ],
  },
  {
    id: 4,
    company: "Alacriti Info Systems",
    role: "Software Engineer",
    fromDate: new Date("2017-06-01"),
    toDate: new Date("2019-05-31"),
    tasks: [
      "Developed Angular 4 applications and REST APIs to support millions of transactions in real-time",
      "Created dynamic visual reports using amCharts and advanced data filtering",
      "Engineered custom data tables supporting thousands of rows with legacy browser support (IE11)",
      "Built an automation testing system to validate REST APIs against Swagger specs",
    ],
  },
  {
    id: 5,
    company: "Hospital Management System",
    role: "Full-Stack Developer",
    fromDate: new Date("2024-01-01"),
    toDate: new Date("2024-03-01"),
    tasks: [
      "Built a serverless healthcare platform using AWS Lambda, API Gateway, and DynamoDB",
      "Created REST APIs in JavaScript and managed 7 domain-specific DynamoDB tables",
      "Integrated user input forms with backend services to capture patient, billing, and operational data",
      "Configured IAM roles and API Gateway throttling for basic security and scalability",
    ],
  }
];


const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

const Experience = () => {
  const monthDiff = (dateFrom, dateTo) => {
    return (
      dateTo.getMonth() -
      dateFrom.getMonth() +
      12 * (dateTo.getFullYear() - dateFrom.getFullYear())
    );
  };

  return (
    <Container>
      <motion.div
        initial={{ opacity: 0, y: 300 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
      >
        <SectionTitle>Work Experience</SectionTitle>

        <TimeLine>
          {data
            .map((ex) => (
              <TimeLineItem key={ex.id}>
                <ExperieceHeader>
                  <h3>
                    {ex.role}, {ex.company}
                  </h3>

                  <small>
                    {months[ex.fromDate.getMonth()] +
                      " " +
                      ex.fromDate.getFullYear()}{" "}
                    -{" "}
                    {ex.toDate.toDateString() === new Date().toDateString() ? (
                      "Present "
                    ) : (
                      <span>
                        {months[ex.toDate.getMonth()] +
                          " " +
                          ex.toDate.getFullYear()}{" "}
                      </span>
                    )}
                    ({monthDiff(ex.fromDate, ex.toDate)}{" "}
                    {monthDiff(ex.fromDate, ex.toDate) > 1 ? "Months" : "Month"}
                    )
                  </small>
                </ExperieceHeader>

                <TaskList>
                  {ex.tasks.map((task, i) => (
                    <li key={i}>{task}</li>
                  ))}
                </TaskList>
              </TimeLineItem>
            ))}
        </TimeLine>
      </motion.div>
    </Container>
  );
};

export default Experience;

const TimeLine = styled.ul`
  list-style-type: none;
  margin: 1em 0;
  padding: 1em;
`;

const TimeLineItem = styled.li`
  padding: 0 0 2em 2em;
  border-left: 1px solid var(--accent-blue);
  position: relative;
  &::after {
    content: "";
    position: absolute;
    top: -4px;
    left: -6px;
    padding: 4px;
    border-radius: 50%;
    background-color: var(--accent-blue);
    border: 2px solid var(--accent-blue);
  }

  p {
    opacity: 0.7;
  }

  ul {
    padding: 0 1em;
  }
`;

const ExperieceHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  position: relative;
  top: -10px;

  h3 {
    font-weight: 400;
  }

  small {
    opacity: 0.8;
  }

  @media (max-width: 768px) {
    display: block;
  }
`;

const TaskList = styled.ul`
  list-style-type: circle;

  li {
    color: var(--para-gray-color);
  }
`;
